import { getAuditHistory, getActionProgress, getActionStepLog } from "@/apis";


export const AuditDataProvider = {
  getList: async ({ resource, pagination, filters, sorters, meta }) => {
    let response;

    if(meta.type == "action"){
      response = await getActionProgress(meta.id, meta.resType, {current:pagination.current, pageSize:pagination.pageSize, filters, sorters});
    } else {
      response = await getAuditHistory(meta.id, meta.resType, {current:pagination.current, pageSize:pagination.pageSize, filters, sorters});
    }
    if (response.status === "error") {
      throw new Error(response.error);
    } else {
      const data = response.value;
      return {
          data,
          total: response.total||meta._total_,
      };
    }
  },  
};
